export const getFieldMessages = (response, formFields, formValues) => {
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
        const currentField = formFields[index];
        const currentValue = formValues[currentField].value;

        let hasError = false;
        let errorMessage = "";

        let errors = response.errors || null;

        if (errors !== null) {
            let requestErrorField = errors[currentField] || null;

            if (requestErrorField !== null) {
                hasError = true;
                errorMessage = requestErrorField[0];
            }
        }

        newFormValues = {
            ...newFormValues,
            [currentField]: {
                ...newFormValues[currentField],
                value: currentValue,
                error: hasError,
                errorMessage: errorMessage,
            },
        };
    }

    return newFormValues;
};

export const getFieldMessagesTemplateCreate = (response, formFields, formValues) => {
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
        const currentField = formFields[index];
        const currentValue = formValues[currentField].value;

        if (Array.isArray(currentValue)) {
            let updatedArray = [];
            let hasError = false;
            let errorMessage = "";

            for (let ii = 0; ii < Object.keys(currentValue).length; ii++) {
                let currentText = currentValue[ii].text;
                let currentType = currentValue[ii].type;

                if (currentType === "BODY") {
                    let example = currentValue[ii]?.example || null;

                    let errors = response.errors || null;

                    if (errors) {
                        let requestErrorField =
                            errors[`${currentField}.${ii}.text`] ||
                            errors[`${currentField}.${ii}.example.body_text.0.${ii}`] ||
                            null;

                        if (requestErrorField !== null) {
                            hasError = true;
                            errorMessage = requestErrorField[0];
                        }
                    }

                    updatedArray.push({
                        text: currentText,
                        type: currentType,
                        example: example,
                    });
                } else {
                    updatedArray.push(currentValue[ii]);
                }
            }

            newFormValues = {
                ...newFormValues,
                [currentField]: {
                    ...newFormValues[currentField],
                    value: updatedArray,
                    error: hasError,
                    errorMessage: errorMessage,
                },
            };
        } else {
            let hasError = false;
            let errorMessage = "";

            let errors = response.errors || null;

            if (errors !== null) {
                let requestErrorField = errors[currentField] || null;

                if (requestErrorField !== null) {
                    hasError = true;
                    errorMessage = requestErrorField[0];
                }
            }

            newFormValues = {
                ...newFormValues,
                [currentField]: {
                    ...newFormValues[currentField],
                    value: currentValue,
                    error: hasError,
                    errorMessage: errorMessage,
                },
            };
        }
    }

    return newFormValues;
};

export const getFieldMessagesNameArray = (response, formFields, formValues) => {
    let newFormValues = { ...formValues };

    for (let i = 0; i < formFields.length; i++) {
        const currentFieldArray = formFields[i];

        if (Object.keys(formValues[currentFieldArray]).length > 3) {
            const currentFieldArrayKeys = Object.keys(formValues[currentFieldArray]);
            const currentFieldArrayValues = formValues[currentFieldArray];

            for (let ii = 0; ii < currentFieldArrayKeys.length; ii++) {
                let currentValue = currentFieldArrayValues[currentFieldArrayKeys[ii]].value;

                let hasError = false;
                let errorMessage = "";

                let errors = response.errors || null;

                if (errors !== null) {
                    let requestErrorField = errors[`${currentFieldArray}[${currentFieldArrayKeys[ii]}]`] || null;

                    if (requestErrorField !== null) {
                        hasError = true;
                        errorMessage = requestErrorField[0];
                    }
                }

                newFormValues = {
                    ...newFormValues,
                    [currentFieldArray]: {
                        ...newFormValues[currentFieldArray],
                        [currentFieldArrayKeys[ii]]: {
                            ...newFormValues[currentFieldArray][currentFieldArrayKeys[ii]],
                            value: currentValue,
                            error: hasError,
                            errorMessage: errorMessage,
                        },
                    },
                };
            }
        } else {
            const currentValue = formValues[currentFieldArray].value;

            let hasError = false;
            let errorMessage = "";

            let errors = response.errors || null;

            if (errors !== null) {
                let requestErrorField = errors[currentFieldArray] || null;

                if (requestErrorField !== null) {
                    hasError = true;
                    errorMessage = requestErrorField[0];
                }
            }

            newFormValues = {
                ...newFormValues,
                [currentFieldArray]: {
                    ...newFormValues[currentFieldArray],
                    value: currentValue,
                    error: hasError,
                    errorMessage: errorMessage,
                },
            };
        }
    }

    return newFormValues;
};

export const getFieldMessagesNameOnlyArray = (response, formFields, formValues) => {
    let newFormValues = { ...formValues };

    for (let i = 0; i < formFields.length; i++) {
        const currentFieldArray = formFields[i];
        const currentFieldArrayKeys = Object.keys(formValues[currentFieldArray]);
        const currentFieldArrayValues = formValues[currentFieldArray];

        for (let ii = 0; ii < currentFieldArrayKeys.length; ii++) {
            let currentValue = currentFieldArrayValues[currentFieldArrayKeys[ii]].value;

            let hasError = false;
            let errorMessage = "";

            let errors = response.errors || null;

            if (errors !== null) {
                let requestErrorField = errors[`${currentFieldArray}[${currentFieldArrayKeys[ii]}]`] || null;

                if (requestErrorField !== null) {
                    hasError = true;
                    errorMessage = requestErrorField[0];
                }
            }

            newFormValues = {
                ...newFormValues,
                [currentFieldArray]: {
                    ...newFormValues[currentFieldArray],
                    [currentFieldArrayKeys[ii]]: {
                        ...newFormValues[currentFieldArray][currentFieldArrayKeys[ii]],
                        value: currentValue,
                        error: hasError,
                        errorMessage: errorMessage,
                    },
                },
            };
        }
    }

    return newFormValues;
};

export const getResponseMessage = (response) => {
    let responseMessage = null;

    if (response?.message) {
        responseMessage = response?.message;
    }

    return responseMessage;
};
